export default __webpack_public_path__ + "static/media/call.235b5904.svg";